import { marked } from 'marked';
import { DEFAULT_LANG, type Lang } from '@/i18n';

/**
 * Pages légales, en markdown dans le dépôt — même mécanique que le blog :
 * `import.meta.glob(..., { eager: true })` est une transformation statique de
 * Vite, le contenu est inliné au build. Aucun import dynamique (règle du
 * dépôt), aucun accès disque au runtime, rien à monter dans l'image Docker.
 *
 * Nom de fichier : `<page>.<lang>.md` (ex. `privacy.fr.md`).
 */
const RAW_PAGES = import.meta.glob('../content/legal/*.md', { eager: true, as: 'raw' }) as Record<string, string>;

export type LegalPageName = 'privacy' | 'terms' | 'extensions-privacy' | 'extensions-terms';

function keyFor(page: LegalPageName, lang: Lang): string {
  return `${page}.${lang}`;
}

const PAGES: Record<string, string> = Object.fromEntries(
  Object.entries(RAW_PAGES).map(([path, raw]) => {
    const file = path.split('/').pop() || '';
    return [file.replace(/\.md$/, ''), raw];
  }),
);

/** Retombe sur la langue par défaut si la traduction n'existe pas encore. */
export function legalMarkdown(page: LegalPageName, lang: Lang): string | null {
  return PAGES[keyFor(page, lang)] ?? PAGES[keyFor(page, DEFAULT_LANG)] ?? null;
}

export function renderLegal(markdown: string): string {
  return marked.parse(markdown, { async: false }) as string;
}
